import React from 'react';
import './StreakDisplay.css';

interface StreakDisplayProps {
  streak: number;
  streakScore: number;
  visible: boolean;
}

const StreakDisplay: React.FC<StreakDisplayProps> = ({
  streak,
  streakScore,
  visible
}) => {
  if (!visible || streak === 0) {
    return null;
  }

  return (
    <div className="streak-display">
      <div className="streak">
        Current Streak: {streak} day{streak !== 1 ? 's' : ''}
      </div>
      <div className="streak-score">
        Streak Score: {streakScore}
      </div>
    </div>
  );
};

export default StreakDisplay;
